// extracted by mini-css-extract-plugin
export default {"root":"styles_root__u6RHk","label":"styles_label__vfYPH"};